import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { McpActivityPage } from '@/pages/super-admin/mcp/McpActivityPage';

const mcpActivitySearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(25),
	actorUserId: z.string().optional(),
	from: z.string().optional(),
	to: z.string().optional(),
	targetCompanyId: z.string().optional(),
	method: z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']).optional(),
	statusClass: z.enum(['2xx', '4xx', '5xx']).optional(),
	contentRead: z.enum(['true', 'false']).optional(),
	search: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/mcp-activity')({
	component: McpActivityPage,
	validateSearch: mcpActivitySearchSchema,
});
